import { cacheState, cachedState } from '../utils'
import Vue from 'vue'

const state = cachedState({
  website: null,
  needsCopy: false,
  sitePackage: null
})

const getters = {
  hasWebsite (state) {
    return state.website != null
  }
}

const mutations = {
  setWebsite (state, website) {
    state.website = website
    cacheState(state)
  },

  setNeedsCopy (state, needsCopy) {
    state.needsCopy = needsCopy
    cacheState(state)
  },

  setSitePackage (state, sitePackage) {
    state.sitePackage = sitePackage
    cacheState(state)
  },

  reset (state) {
    state.website = null
    state.needsCopy = false
    state.sitePackage = null
    cacheState(state)
  }
}

const actions = {
  setWebsite ({ state, commit, dispatch }, website) {
    commit('setWebsite', website)
    return dispatch('proceed', null, { root: true })
  },

  setSitePackage ({ state, commit, dispatch }, sitePackage) {
    commit('setSitePackage', sitePackage)
    return dispatch('proceed', null, { root: true })
  },

  async createLead ({ commit, dispatch, state, getters }, params) {
    await Vue.api.createLead({
      ...params,
      hadAWebsite: getters.hasWebsite != null,
      wannaCopySite: state.needsCopy,
      currentWebsiteUrl: state.website,
      packageId: state.sitePackage.id
    })
    return dispatch('proceed', null, { root: true })
  },

  reset ({ commit }) {
    commit('reset')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/help-flow.js